module.exports = __webpack_public_path__ + "img/wap_logo@2x.560621f6.png";